import Spinning from 'app/components/Spinning'

export default ({ className = '' }) => {
  return (
    <div className="text-8xl text-white flex-1 fcol items-center justify-center">
      <Spinning />
    </div>
  )
}
